import styled from 'styled-components';
import CancelSvg from '../../assets/mytrips/cancel-booking.svg';

const CancelBookingIcon = styled(CancelSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default CancelBookingIcon;
